module.exports = {
      id: "icons:caret-up-usage",
      viewBox: "0 0 8 4",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#icons:caret-up-usage",
      toString: function () {
        return this.url;
      }
    }